import { render, staticRenderFns } from "./teacherReg.vue?vue&type=template&id=1009f92d&scoped=true&"
import script from "./teacherReg.vue?vue&type=script&lang=js&"
export * from "./teacherReg.vue?vue&type=script&lang=js&"
import style0 from "./teacherReg.vue?vue&type=style&index=0&id=1009f92d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1009f92d",
  null
  
)

export default component.exports